import React, { Component } from 'react';
import { withRouter } from 'react-router';
import EmptyState from '../EmptyState';
import { ProjectLineItem } from './ViewComp';
import Pagination from '../../Common/Pagination';
import { hasSpinner } from '../../Common/Spinner';
import { hasProjectListData } from './ProjectListData';
import config from '../../../config';
import StateStore from '../../Common/StateStore';
import getEditingPath from '../../Common/Helpers/GetEditingPath';
import { HTMLTrans } from '../../Common/Translations';

class ProjectList extends Component {
  constructor(props) {
    super(props);
    this.renderLineItem = this.renderLineItem.bind(this);
  }

  renderLineItem(props, index) {
    return (
      <StateStore key={`${props.name}-${index}`}>
        {(state, handler) => (
          <div>
          <ProjectLineItem
            {...props}
            {...this.props}
            onEditProject={getEditingPath(props.id, props.family.editor_module_id)}
            onDuplicate={() => {
              this.props.duplicate(props);
            }}
            onDelete={() => {
              this.props.delete(props);
            }}
            onUpdate={this.props.update}
            {...state}
            onBlur={() => { handler({ isEditing: false }); }}
            onRename={() => { handler({ isEditing: true }); }}
          />
          <hr className='bg-gray-lighten-1 my-5'/>
        </div>
        )}
      </StateStore>
    );
  }

  render() {
    const {
      projectListData = [],
      lastPage,
      currentPage,
      getData,
      tRoute
    } = this.props;

    const data = {
      heading: <HTMLTrans id="account.project_projectlist_data_heading">My Projects</HTMLTrans>,
      body: {
        header: <p><HTMLTrans id="account.project_projectlist_data_body_header">You do not have an existing project, start one now!</HTMLTrans></p>,
      },
      ctaButtons: [{
        type: 'primary', refresh: true, label: <HTMLTrans id="account.project_projectlist_data_button">Create A Project Now</HTMLTrans>, url: tRoute('/product'),
      }],
    };

    if (projectListData.length < 1) {
      return <EmptyState data={data}/>;
    }

    const taopixLink = <a target='_blank' href={config.taopixStoreUrl}>here</a>;
    return (
      <div className='dashboard-card'>
        <h3>{data.heading}</h3>
        <hr />
        <div className='container my-5'>
          {projectListData.map(this.renderLineItem)}
        </div>
        <Pagination lastPageNumber={lastPage}
                    currentPageNumber={currentPage}
                    onClick={getData}/>
      </div>
    );
  }
}

export default hasProjectListData(hasSpinner)(withRouter(ProjectList));
export const undecorated = ProjectList;



// WEBPACK FOOTER //
// ./src/Account/Project/ProjectList.js